import { CookiePrefence } from '@shared/models/cookie-preference.model';

export const convertObjToCookieValue = (cookiePrefence: CookiePrefence) => {
  const cookieValue = Object.entries(cookiePrefence)
    .map(([value, key]) => `${value}:${key}`)
    .join('_');
  return cookieValue;
};
